export default __webpack_public_path__ + "static/Element_Ore-6e8f92c1ee706edfb2c53bcecc9d461a.png";